import { validateEmail } from './validator';

export const syncValidation = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!validateEmail(values.email)) {
    errors.email = 'Wrong email format';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./utils/loginValidator.js